import React, { useMemo } from "react"

import { ProductPosition } from "shared/types/ProductPosition"

import { FAVORITES_PROJECT_ID } from "entities/favorites/api/useFavoriteMutations"
import { ProductPositionMultiSelectSidebar } from "pages/project-page/sidebar/multi/product-position/ProductPositionMultiSelectSidebar"
import { useProductPositionMultiSelectSidebarModel } from "pages/project-page/sidebar/multi/product-position/hooks/useProductPositionMultiSelectSidebarModel"
import { MultiEditProductPositionFormOptions } from "widgets/multi-edit-product-position-form/ui/MultiEditProductPositionFormView"

export interface FavoritesPageProductPositionSidebarProps {
  productPositions: ProductPosition[]
}

const FAVORITES_SIDEBAR_FORM_OPTIONS: MultiEditProductPositionFormOptions = {
  hideQuantity: true
}

export const FavoritesPageProductPositionMultiSelectSidebarConnector =
  React.memo(
    ({ productPositions }: FavoritesPageProductPositionSidebarProps) => {
      const model = useProductPositionMultiSelectSidebarModel({
        productPositions,
        projectID: FAVORITES_PROJECT_ID
      })

      const callbacks = useMemo(
        () => ({
          ...model.callbacks,
          onDuplicate: undefined,
          onDelete: undefined
        }),
        [model.callbacks]
      )

      return (
        <ProductPositionMultiSelectSidebar
          {...model}
          callbacks={callbacks}
          canEdit={false}
          className="favorites-sidebar"
          formOptions={FAVORITES_SIDEBAR_FORM_OPTIONS}
        />
      )
    }
  )
